export default __webpack_public_path__ + "static/1298-5807abe0eefeb5be66da6d9b32e4e8f8.gif";